<template>
  <div>
    <v-alert type="error" style="display: flex; margin-top: 0px; margin-bottom: 0px;" v-show="zeroResults">
        Google konnte keine gültige Route ermitteln. Eventuell liegen Wegpunkte abseits von offiziellen Straßen.
    </v-alert>
    <div v-show="mapInitialized" class="liefermaxmap" id="liefermaxmap" ref="liefermaxmap"></div>
  </div>
</template>
<script>
export default {
  name: 'LiefermaxMap',
  props: ['waypoints', 'stopOver', 'showMarker', 'drivenTour'],
  data: function() {
    return {
      mapName: 'liefermaxmap',
      mapInitialized: false,
      directionsService: null,
      directionsDisplay: null,
      vueGMap: null,
      bounds: null,
      markers: [],
      combinedDirections: null,
      zeroResults: false
    };
  },
  watch: {
    waypoints(newValue, oldValue) {
      console.log('Waypoints changed, count: ' + newValue.length);
      console.log(newValue);
      this.initMap();
      this.markers = [];
    },
    showMarker(newValue, oldValue) {
      this.initMap();
      this.markers = [];
    },
    drivenTour(newValue, oldValue) {
      this.initMap();
      this.markers = [];
    },
    stopOver(newValue, oldValue) {
      this.initMap();
      this.markers = [];
    }
  },
  methods: {
    initMap: function() {
      var mapOptions = {
        zoom: 8,
        center: this.waypoints['driver'],
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        panControl: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        panControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        scaleControl: false,
        streetViewControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      };
      var map = new google.maps.Map(this.$refs['liefermaxmap'], mapOptions);
      // Instantiate a directions service.
      var directionsService = new google.maps.DirectionsService();
      var directionsDisplay = new google.maps.DirectionsRenderer({
        map: map,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: 'red'
        }
      });
      var directionsServiceTour = new google.maps.DirectionsService();
      var directionsDisplayTour = new google.maps.DirectionsRenderer({
        map: map,
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: 'blue'
        }
      });
      var drivermarker = new google.maps.Marker({
        position: new google.maps.LatLng(this.waypoints['driver']),
        map: map,
        icon: 'http://maps.google.com/mapfiles/ms/micons/truck.png'
      });

      if (this.drivenTour) {
        const waypointsTour = this.getWayPoints(true, map);
        if (waypointsTour.length > 0) {
          this.calculateAndDisplayRoute(directionsServiceTour, directionsDisplayTour, waypointsTour, this);
        }
      }
      if (this.stopOver) {
        const waypointsCalc = this.getWayPoints(false, map);

        if (this.drivenTour) {
          // short dalay before seccond route gets requested, google don't like to many requests at once
          setTimeout(() => {
            if (waypointsCalc.length > 0) {
              this.calculateAndDisplayRoute(directionsService, directionsDisplay, waypointsCalc, this);
            }
          }, 2000);
        } else {
          if (waypointsCalc.length > 0) {
            this.calculateAndDisplayRoute(directionsService, directionsDisplay, waypointsCalc, this);
          }
        }
      }

      this.directionsService = directionsService;
      this.directionsDisplay = directionsDisplay;
      this.vueGMap = map;

      this.mapInitialized = true;
    },
    getWayPoints: function(tour, map) {
      var points = [];
      var googleWaypoints = [];

      if (tour) {
        points = this.waypoints['tour'];
      } else {
        points = this.waypoints['calculatedTour'];
      }

      console.log('Points:    ---');
      console.log(points);

      // we need to create a array with all google waypoints
      if (points != []) {
        points.forEach(element => {
          const pos = new google.maps.LatLng(element.lat, element.lng);
          const wp = { location: pos, stopover: false };

          googleWaypoints.push(wp);
          console.log(element);

          if (element.done === true) {
            this.addWaypointMarker(pos, 'green', element, map);
          } else {
            this.addWaypointMarker(pos, 'red', element, map);
          }
        });
      }

      return googleWaypoints;
    },
    calculateAndDisplayRoute: function(directionsService, directionsDisplay, points, data) {
      console.log(points);

      let requests = []; let chunk = 20;
      var i; var j; var temparray; var reqCount = 0;

      // we need to cut if we have to many waypoints google has a max
      if (points.length > chunk) {
        for (i = 0, j = points.length; i < j; i += chunk) {
          temparray = points.slice(i, i + chunk);

          var request = {
            origin: 'Roßhaupten, Am Roten Kreuz 6',
            destination: 'Roßhaupten, Am Roten Kreuz 6',
            waypoints: temparray,
            // optimizeWaypoints: true,
            travelMode: 'WALKING'
          };

          requests.push(request);
        }
      } else {
        var request = {
          origin: 'Roßhaupten, Am Roten Kreuz 6',
          destination: 'Roßhaupten, Am Roten Kreuz 6',
          waypoints: points,
          travelMode: 'WALKING'
        };
        requests.push(request);
      }

      console.log('Requests: wwww');
      console.log(requests);
      requests.forEach(request => {
        directionsService.route(request, function(response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
            data.zeroResults = false;
          } else if (status === 'ZERO_RESULTS') {
            data.zeroResults = true;
          }
          console.log(data.zeroResults);
          reqCount += 1;
        });
      });
    },
    addWaypointMarker(latLng, color, element, map) {
      if (!this.showMarker) {
        return;
      }
      let url = 'http://maps.google.com/mapfiles/ms/icons/' + color + '-dot.png';

      let marker = new google.maps.Marker({
        map: map,
        position: latLng,
        icon: {
          url: url
        }
      });

      var customerName = 'no name';
      if (typeof element.customer !== 'undefined') {
        customerName = (typeof element.customer.name !== 'undefined') ? element.customer.name : 'no name';
      }

      var infowindow = new google.maps.InfoWindow({
        content: customerName
      });

      marker.addListener('mouseover', function() {
        infowindow.open(map, marker);
      });
      marker.addListener('mouseout', function() {
        infowindow.close(map, marker);
      });
    },

    /*
#
# Old Code from Pascal
#
*/

    initGoogleMaps: function() {
      const localOptions = {
        zoom: 8,
        center: this.waypoints['driver'],
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        panControl: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        panControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.LARGE,
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        scaleControl: false,
        streetViewControl: false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      };

      this.vueGMap = new google.maps.Map(
        this.$refs['liefermaxmap'],
        localOptions
      );

      // eslint-disable-next-line
      var drivermarker = new google.maps.Marker({
        position: new google.maps.LatLng(this.waypoints['driver']),
        map: this.vueGMap,
        icon: 'http://maps.google.com/mapfiles/ms/micons/truck.png'
      });

      this.directionsService = new google.maps.DirectionsService();
      this.directionsDisplay = new google.maps.DirectionsRenderer({
        suppressMarkers: !this.showMarker
      });
      this.directionsDisplay.setMap(this.vueGMap);

      this.setWaypoints();
      this.combinedDirections = null;
      this.mapInitialized = true;
    },
    addMarker(latLng, color, element) {
      if (!this.showMarker) {
        return;
      }
      let url = 'http://maps.google.com/mapfiles/ms/icons/';
      url += color + '-dot.png';

      let marker = new google.maps.Marker({
        map: this.vueGMap,
        position: latLng,
        icon: {
          url: url
        }
      });

      if (this.stopOver) {
        var infowindow = new google.maps.InfoWindow({
          content: element.customer.name
        });

        marker.addListener('mouseover', function() {
          infowindow.open(this.vueGMap, marker);
        });
        marker.addListener('mouseout', function() {
          infowindow.close(this.vueGMap, marker);
        });
      }
    },
    setWaypoints() {
      var googleWaypoints = [];
      this.waypoints['tour'].forEach(element => {
        var pos = new google.maps.LatLng(element.lat, element.lng);
        var wp = { location: pos, stopover: false };
        googleWaypoints.push(wp);
        console.log(element);
        if (element.done === true) {
          this.addMarker(pos, 'green', element);
        } else {
          this.addMarker(pos, 'red', element);
        }
      });

      var i = 0;
      var j = 0;
      var temparray = [];
      var chunk = 20;

      var requests = [];
      for (i = 0, j = googleWaypoints.length; i < j; i += chunk) {
        temparray = googleWaypoints.slice(i, i + chunk);
        var request = {
          origin: 'Roßhaupten, Am Roten Kreuz 6',
          destination: 'Roßhaupten, Am Roten Kreuz 6',
          travelMode: 'WALKING',
          waypoints: temparray
        };
        requests.push(request);
      }
      this.directionsDisplay.set('directions', null);
      this.loadGoogleMapsRoute(requests);
    },
    loadGoogleMapsRoute(requests) {
      const req = requests;
      console.log(req.length);
      if (req.length === 0) {
        console.log('first is null');
        this.directionsDisplay.set('directions', this.combinedDirections);
        return;
      }
      var first = req.shift();
      this.directionsService.route(first, (result, status) => {
        if (status === 'ZERO_RESULTS') {
          console.log('Zero Results occured, trying another Travelmode');
          first.travelMode = 'DRIVING';
          setTimeout(() => {
            this.loadGoogleMapsAlternativeRoute(first);
            this.loadGoogleMapsRoute(req);
          }, 1000);
          return;
        }
        if (status === 'OK') {
          if (this.combinedDirections == null) {
            this.combinedDirections = result;
          } else {
            this.combinedDirections.routes[0].legs = this.combinedDirections.routes[0].legs.concat(
              result.routes[0].legs
            );
            this.combinedDirections.routes[0].overview_path = this.combinedDirections.routes[0].overview_path.concat(
              result.routes[0].overview_path
            );
            this.combinedDirections.routes[0].bounds = this.combinedDirections.routes[0].bounds.extend(
              result.routes[0].bounds.getNorthEast()
            );
            this.combinedDirections.routes[0].bounds = this.combinedDirections.routes[0].bounds.extend(
              result.routes[0].bounds.getSouthWest()
            );
          }
          console.log(result);
          setTimeout(() => {
            this.loadGoogleMapsRoute(req);
          }, 1000);
        }
      });
    },
    googleMapsFailedToLoad() {
      this.vueGMap = 'Error while loading map';
    },
    loadGoogleMapsAlternativeRoute(request) {
      this.directionsService.route(request, (result, status) => {
        if (status === 'OK') {
          this.combinedDirections.routes[0].legs = this.combinedDirections.routes[0].legs.concat(
            result.routes[0].legs
          );
          this.combinedDirections.routes[0].overview_path = this.combinedDirections.routes[0].overview_path.concat(
            result.routes[0].overview_path
          );
          this.combinedDirections.routes[0].bounds = this.combinedDirections.routes[0].bounds.extend(
            result.routes[0].bounds.getNorthEast()
          );
          this.combinedDirections.routes[0].bounds = this.combinedDirections.routes[0].bounds.extend(
            result.routes[0].bounds.getSouthWest()
          );
          console.log(result);
        } else {
          console.log('alternative route failed');
          console.log(result);
          console.log(status);
        }
      });
    }
  },
  mounted() {
    this.initMap();
    console.log('www Driver: ');
    console.log(this.waypoints['driver']);
    console.log('www Waypoints: ');
    console.log(this.waypoints);
  }
};
</script>
<style scoped>
.liefermaxmap {
  width: 100%;
  height: 100%;
}
</style>
